module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"form_file":{"select_file":"Selecione o arquivo","file_selected":"Arquivo selecionado","files_selected":"{0} arquivos selecionados"}},"en":{"form_file":{"select_file":"Selecione file","file_selected":"File selected","files_selected":"{0} files selected"}}}')
  delete Component.options._Ctor
}
